export function setValidityMessage(elem) {
  const validity = elem.validity;
  const type = elem.type;
  let msg = '';

  if (!validity.valid) {
    if (validity.valueMissing) {
      msg = 'ERROR_REQUIRED';
    } else if (validity.typeMismatch) {
      if (type === 'tel') {
        msg = 'Invalid phone number';
      } else {
        msg = 'invalid type';
      }
    } else if (validity.patternMismatch) {
      msg = 'invalid pattern';
    }
  }
  if (!validity.customError) {
    elem.setCustomValidity(msg);
  }
}

export function getValidityMessage(elem) {
  const validity = elem.validity;
  const type = elem.type;
  let msg = '';
  if (!validity.valid) {
    if (validity.valueMissing) {
      msg = 'ERROR_REQUIRED';
    } else if (validity.typeMismatch) {
      if (type === 'tel') {
        msg = 'Invalid phone number';
      } else {
        msg = 'Invalid type';
      }
    } else if (validity.patternMismatch) {
      if (elem.type === "password"){
        msg = "ERROR_PASSWORD_PATTERN";
      } else {
        const patternMsg = elem.getAttribute("data-pattern-message");
        msg = patternMsg ? patternMsg : 'Invalid pattern';
      }
    } else if (validity.rangeOverflow){
      msg = "ERROR_NUMBER_TOO_LARGE"
    } else if (validity.rangeUnderflow){
      msg = "ERROR_NUMBER_TOO_SMALL"
    } else if (validity.stepMismatch){
      msg = "ERROR_INVALID_NUMBER_FORMAT";
    }

    if (validity.customError) {
      msg = elem.validationMessage;
    }
  }
  return msg;

}

export function validateEmail(elem) {
  // eslint-disable-next-line
  const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let msg = "";
  if (elem.value !== undefined && elem.value !== "") {
    const isValid = emailRegex.test(elem.value);
    if (!isValid) {
      msg = "ERROR_EMAIL";
      elem.setCustomValidity(msg);
      return false;
    }
  }
  return true;
}

export function validateEqual(elem1, elem2, errorMsg) {
  if (elem1.value !== elem2.value) {
    elem1.setCustomValidity(errorMsg);
    elem2.setCustomValidity(errorMsg);
    return false;
  }
  return true;
}

export function onlyNumbersOnKeyPress(event){
  const keyCode = event.keyCode || event.which;
  if (keyCode !== 13) { //enter key
    const keyValue = String.fromCharCode(keyCode);
    if (/\D/.test(keyValue)) {
      event.preventDefault();
    }
  }
}